import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles, perm }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  if (loading) return <div className="p-8 text-center text-slate-500">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  // Se `perm` fornecido, super_admin sempre passa; funcionário precisa da permissão.
  if (perm && user.role !== "super_admin") {
    const userPerms = user.permissoes || [];
    if (!userPerms.includes(perm)) {
      // Redireciona para a primeira aba permitida (evita loop)
      const order = ["inscricoes.view", "dashboard", "nova-inscricao", "vulnerabilidades", "inscricoes.exportar"];
      const targetToPath = {
        "inscricoes.view": "/admin/inscricoes",
        "dashboard": "/admin",
        "nova-inscricao": "/admin/nova-inscricao",
        "vulnerabilidades": "/admin/vulnerabilidades",
        "inscricoes.exportar": "/admin/relatorios",
      };
      const target = order.find((p) => userPerms.includes(p));
      const targetPath = target ? targetToPath[target] : "/";
      if (targetPath === pathname) return <Navigate to="/" replace />;
      return <Navigate to={targetPath} replace />;
    }
  }
  return children;
}
